<template>
  <multiselect :id="id" v-model="value" :classes="attributes.classes != undefined? attributes.classes.value: ''" :options="options" :loading="isLoading" :multiple="this.attributes.multiple != undefined && this.attributes.multiple.value ? this.attributes.multiple.value : false" :placeholder="this.attributes.placeholder != undefined ? this.attributes.placeholder.value: ''" :disabled="disabled || (alwaysLocked != null && alwaysLocked)" :label="labelField" :trackBy="labelField" selectLabel="" :deselectLabel="deselectLabel" :selectedLabel="selectedLabel" :allow-empty="this.attributes.required && this.attributes.required.value ? !this.attributes.required.value : true" @input="onChange">
    <template v-if="!disabled && (this.attributes.required == undefined || !this.attributes.required.value)" slot="clear">
      <div class="multiselect__clear" v-if="value" @mousedown.prevent.stop="clearAll()">
        <i class="fas fa-times"></i>
        <!-- <i class="fas fa-times">
          <span aria-hidden="true" class="sr-only">{{ "clear" | translate }}</span>
        </i> -->
      </div>
    </template>
  </multiselect>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: {Multiselect},

    props: ['id', 'attributes', 'reset', 'locked', 'selected'],

    data () {
      return {
        disabled: false,
        value: null,
        options: [],
        selectedLabel: this.$options.filters.translate("selected"),
        noResult: this.$options.filters.translate("noResult"),
        idField: 'id',
        labelField: 'label',
        isLoading: false,
        ready: false,
        alwaysLocked: null
      }
    },

    created() {
      if(this.attributes.idField != undefined)
        this.idField = this.attributes.idField.value;

      if(this.attributes.labelField != undefined)
        this.labelField = this.attributes.labelField.value;

      if(this.attributes.alwaysLocked != undefined)
        this.alwaysLocked = this.attributes.alwaysLocked.value;

      if(this.selected != undefined)
        this.value = this.selected;
      else if(this.attributes.value != undefined)
        this.value = this.attributes.value.value;

      if(this.attributes.options != undefined) {
        this.options = this.attributes.options.value;

        if(this.value != null)
          this.setValueFromOption();
      }
      
      if(this.locked != undefined && this.locked)
        this.disabled = this.locked;
      else if(this.attributes.disabled != undefined && this.attributes.disabled.value)
        this.disabled = this.attributes.disabled.value;

      if(this.value != null) {
        if(this.value[this.idField] != undefined)
          this.broadcast(this.value[this.idField]);
        else
          this.broadcast(this.value);
      }
    },

    mounted() {
      this.ready = true;
    },

    watch: {
      reset() {
        this.clearAll();
      },

      'attributes.options.value'() {
        //Disabilito la select
        this.alwaysLocked = true;

        //Elimino il value
        this.$set(this, 'value', null);
        
        this.options = this.attributes.options.value;

        //Reinserisco il nuovo value
        if(this.selected != undefined)
          this.$set(this, 'value', this.selected);
        else if(this.attributes.value != undefined)
          this.$set(this, 'value', this.attributes.value.value);
        
        //Seleziono il valore
        if(this.attributes.value.value != null &&  this.attributes.value.value != undefined)
          this.setValueFromOption();

        //Riabilito la select
        this.alwaysLocked = false;
      },
      
      'attributes.value.value'() {
        if(this.attributes.value.value != null &&  this.attributes.value.value != undefined)
          this.setValueFromOption();
      },

      locked() {
        this.disabled = this.locked;

        if(this.attributes.value.value != null &&  this.attributes.value.value != undefined)
          this.setValueFromOption();
        else
          this.value = null;
      }
    },

    computed: {
      deselectLabel() {
        return '';
      }
    },

    methods: {
      clearAll() {
        this.value = null;
        this.broadcast(this.value, false);
      },
      
      onChange(value) {
        if(value != null && value.length != 0) {
          if(this.attributes.multiple != undefined && this.attributes.multiple.value) {
            let values = [];
            
            for (var i = 0; i < value.length; i++)
              values.push(value[i][this.idField]);

            this.broadcast(values);
          } else {
            this.broadcast(value[this.idField], null, value);
          }
        } else
        this.broadcast(null);
      },
      
      broadcast(value, refresh, object) {
        if(value != undefined && value != null)
          this.$emit('changed', {id: this.id, value: value, object: object, refresh: refresh});
        else
          this.$emit('changed', {id: this.id, value: null, refresh: refresh});
      },

      setValueFromOption(refresh) {
        if(typeof this.value != 'object' && this.value != undefined) {
          for (let index = 0; index < this.options.length; index++) {
            if(this.value[this.idField] == this.options[index][this.idField] || (this.selected != undefined && this.selected == this.options[index][this.idField]) || (this.attributes.value != undefined && this.attributes.value.value == this.options[index][this.idField])) {
              this.$set(this, 'value', this.options[index]);
              this.broadcast(this.value[this.idField], refresh, this.value)
              
              return true;
            }
          }
        }
        
        return false;
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect--active {
    z-index: 4;
  }
  .multiselect {
    height: 36px;
  }
  
  .multiselect__tags {
    min-height: 36px;
  }
  .multiselect__select {
    height: 36px;
    z-index: 5;
  }
  .multiselect__element {
      z-index: 20;
  }
  
  .multiselect__tags, .multiselect__input, .multiselect__single {
    background-color: #434343;
    background: #434343;
    color: #B1B1B1 !important;
    padding-top: 6px;
    padding-left: 10px;
  }
  .has-error .multiselect__tags {
      border-color: #f04124!important;
  }
  .multiselect--disabled,
  .multiselect--disabled > .multiselect__tags,
  .multiselect--disabled > .multiselect__tags > .multiselect__single,
  .multiselect--disabled > .multiselect__tags > .multiselect__spinner,
  .multiselect--disabled > .multiselect__tags > span > .multiselect__single {
    background-color: #eeeeee;
    opacity: 1;
  }
  .multiselect--disabled::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color:#c5cace;
  }
  .multiselect--disabled::-moz-placeholder { /* Firefox 19+ */
    color:#c5cace;
  }
  .multiselect--disabled:-ms-input-placeholder { /* IE 10+ */
    color:#c5cace;
  }
  .multiselect--disabled:-moz-placeholder { /* Firefox 18- */
    color:#c5cace;
  }
  .multiselect__clear {
    cursor: pointer;
    position: absolute;
    right: 45px;
    top: 7px;
    font-size: 18px;
    color: #999999;
    z-index: 3;
  }
  .multiselect__content-wrapper {
    z-index: 15;
  }
  
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 15px;    
  }

  /* BLUE */
  .multiselect-blu {
    
  }
  .multiselect__tags, .multiselect__input, .multiselect__single {
    background-color: #0e5381 ;
    background: #0e5381 ;
    color: rgba(255, 255, 255, 0.8) !important;
  }

  .multiselect__select:before {
    color: rgba(255, 255, 255, 0.8) ;
    border-color: rgba(255, 255, 255, 0.8) transparent transparent;
  }

  .multiselect--disabled  .multiselect__single {
    color: rgba(146, 146, 146, 0.8) !important;
  }
</style>